import React, { useState, useEffect } from "react";
// import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
// import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
// import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

import AngelaIconMultiR1C from "../Common/Angela/AngelaIconMultiR1C";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class GilSqaDashboard extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("");
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  render() {
    return (
      <>
        <SessionError visible={this.state.loginError} />
        <div
          style={{
            background: "#000000",
            paddingTop: 10,
            //   backgroundImage:
            //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
          }}
        >
          <div>
            <Col span={24}>
              <div
                style={{
                  margin: "10px",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    color: "#bdc3c7",
                    fontSize: 28,
                    fontWeight: 400,
                    textAlign: "center",
                    margin: "0px 0px 30px 0px",
                  }}
                >
                  SQA Dashboard
                </div>

                {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}


                {/* _______Row No 1________ */}
                <Row style={{ background: "#000000" }}>
                  <Col style={{ width: "25%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <AngelaIconMultiR1C
                        divId={"Dict001"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict001",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "25%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <AngelaIconMultiR1C
                        divId={"Dict002"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict002",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "25%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <AngelaIconMultiR1C
                        divId={"Dict003"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict003",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "25%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <AngelaIconMultiR1C
                        divId={"Dict004"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict004",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row>
                {/* _______Row No 2________ */}
                <Row style={{ background: "#000000" }}>


                  <Col style={{ width: "50%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict006"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict006",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "50%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict007"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict007",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row>
                {/* _______Row No 3________ */}
                <Row style={{ background: "#000000" }}>
                  

                  <Col style={{ width: "50%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict009"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict009",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "50%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict010"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict010",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row>
                {/* _______Row No 4________ */}
                <Row style={{ background: "#000000" }}>
                

                  <Col style={{ width: "50%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict012"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict012",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "50%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict013"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict013",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row>
                {/* _______Row No 5________ */}
                <Row style={{ background: "#000000" }}>
        

                  <Col style={{ width: "50%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict015"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict015",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "50%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict016"}
                        api={"/sqa4m/dashboard"}
                        urlData={{
                          chartGroup: "GilSqaDashboard",
                          dictName: "Dict016",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row>

                {/* Houdini_DivData */}
              </div>
            </Col>
          </div>
        </div>
      </>
    );
  }
}

export default GilSqaDashboard;
